import { ProgramForm } from '../ProgramForm';
import { ProgramDrawerShell } from './ProgramDrawerShell';
import { useDirtyCloseConfirm } from '../../lib/useDirtyCloseConfirm';
import { useUpsertProgram } from '../../lib/useUpsertProgram';
import { formValuesToCreatePayload } from '../../model/programForm.mapper';
import { SavedProgram } from '../../api/programForm.response';
import {
  DEFAULT_COLOR,
  DEFAULT_CONTENT_STRUCTURE,
  DEFAULT_DURATION_LENGTH,
  DEFAULT_DURATION_UNIT,
  DEFAULT_PUBLISHING_BEHAVIOUR_PROGRAM,
  ProgramFormValues,
} from '../../model/programForm.types';

export type CreateProgramDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  creatorId: number;
  onSaved: (saved: SavedProgram) => void;
};

const CREATE_DEFAULTS: ProgramFormValues = {
  name: '',
  goal: '',
  description: '',
  mediaCover: null,
  mediaIntro: null,
  color: DEFAULT_COLOR,
  tags: [],
  targetArea: [],
  requiredEquipment: [],
  location: '',
  difficulty: '',
  contentStructure: DEFAULT_CONTENT_STRUCTURE,
  publishingBehaviour: DEFAULT_PUBLISHING_BEHAVIOUR_PROGRAM,
  workoutLimit: '',
  durationLength: DEFAULT_DURATION_LENGTH,
  durationUnit: DEFAULT_DURATION_UNIT,
  daysPerWeek: '',
  sessionDuration: '',
  reviewsEnabled: false,
  reviews: [],
  faqsEnabled: false,
  faqs: [],
  inAppPurchaseAllowed: true,
};

export const CreateProgramDrawer = ({
  isOpen,
  onClose,
  creatorId,
  onSaved,
}: CreateProgramDrawerProps) => {
  const { onDirtyChange, attemptClose } = useDirtyCloseConfirm(onClose);
  const { isSubmitting, handleSave } = useUpsertProgram(
    (values) => formValuesToCreatePayload(values, { creatorId }),
    onSaved,
  );

  return (
    <ProgramDrawerShell
      isOpen={isOpen}
      onClose={attemptClose}
      title="Create program"
      testId="create-program-drawer"
    >
      <ProgramForm
        defaultValues={CREATE_DEFAULTS}
        submitLabel="Create"
        isSubmitting={isSubmitting}
        onSave={handleSave}
        onDirtyChange={onDirtyChange}
      />
    </ProgramDrawerShell>
  );
};
